import { nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import { ParticipantResource } from '../../../../../../../../ParticipantsStore/Types';
import { Link } from '../../../../../../../../Resource/Types';
import { T } from '../../../../../../../../Translations';
import { filterParticipants } from '../../../../../../../LearningCollections/LearningCollection/Functions';
import ParticipantDynamicTypeaheadSelect from '../../../../../../../LearningCollections/LearningCollection/ParticipantDynamicTypeaheadSelect';
import AddParticipantStore from '../../../../../Store';
import { ParticipantState } from '../../../../../Store/Types';
import ParticipantsList from './ParticipantsList';

export interface Props {
  link: Link;
  store: AddParticipantStore;
  newParticipants: ReadonlyArray<ParticipantResource>;
  state: ParticipantState;
}

function Body({ link, store, newParticipants, state }: Props) {
  return (
    <>
      <ParticipantDynamicTypeaheadSelect
        newGroups={[]}
        newParticipants={filterParticipants(state.newParticipants)}
        endpoint={link}
        name="participants"
        label="Select Participants or Groups"
        onChange={(o) => store.addParticipant(o)}
        initialValue={nothing()}
        labelClassname="py-1.5 text-sm font-semibold text-gray-800 block"
        placeholder="Enter Participant Name, Email or Group Name"
      />
      <div>
        <div className="font-semibold text-sm pt-4">
          <T kind="Participants to be added ({{count}} selected)" count={newParticipants.length} />
        </div>
      </div>
      <ParticipantsList store={store} newParticipants={newParticipants} />
    </>
  );
}

export default observer(Body);
